namespace Ir.Components.Workbook.DrilldownMultiView {

    interface IDrilldownMultiViewViewModel {
        multiviewConfig: any,
        tabsConfig: DevExpress.ui.dxTabPanel.Properties,
        tabsComponent: DevExpress.ui.dxTabPanel,
        level: KnockoutObservable<number>;

        config: WorkbookConfig;
        onReportTemplateClick: Function;
        callback: Function;

        tabDetailToolbar: DevExpress.ui.dxToolbar.Properties;
        tab: KnockoutObservable<WorkbookTab>;

        dispose: Function;
    }
    
    export function getViewModel(this: IDrilldownMultiViewViewModel, params: any, componentInfo) {
        let self = this;
        let config = params.config as WorkbookConfig;

        let tabOrWidget: ITabOrWidget = params.dashboarWidget ?? config.activeTab();

        this.tab = config.activeTab;
        this.level = tabOrWidget.drilldownManager.activeDrilldownIndex;
        
        this.config = config;
        let reportTemplateListPopoverControl;
        this.callback = function(obj) {
            reportTemplateListPopoverControl = obj;
        }
        this.onReportTemplateClick = function(reportTemplate: Drilldown) {
            let tabOrWidget = config.activeTabOrWidget();
            if (!tabOrWidget?.itemConfig()?.allowEditDrilldown) {
                return;
            }

            if (tabOrWidget.itemConfig().isReportConfig) {
                (tabOrWidget.drilldownManager.getActiveWidget().itemConfig as ReportConfig).templateId(reportTemplate.id);
            }

            tabOrWidget.drilldownManager.getActiveWidget().itemConfig.saveAnalyzeByOrGroupBy(tabOrWidget, reportTemplate, false, true, reportTemplate.name);
        };

        let previousDrilldownIndex = -99999;
        let previousDrilldownId: number = null;

        if (params.dashboarWidget) {
            let tabsPanelResize = function () {
                self.tabsComponent.option("showNavButtons", false);
                self.tabsComponent.option("showNavButtons", true);
            };

            let resizer = new ResizeObserver(irGlobal.debounce(tabsPanelResize, 300));
            resizer.observe(componentInfo.element);
            this.dispose = function () {
                resizer.disconnect();
            };
        }

        let titleTemplate = function(itemData: DrilldownViewListItemVM, itemIndex, itemElement) {
            let $div = $(`<div data-bind="attr: { title: itemData.fullHint }">`);

            if (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted) {
                $div.append($('<i class="ms" data-bind="text: icon, click: showTemplates"></i>'));
            }
    
            let $span = $('<span class="drilldown-tab-name" data-bind="text: tabName "></span>');
            $div.append($span);
            
            let $spanFilters = $('<span data-bind="text: itemData.tabTitle"></span>');
            $div.append($spanFilters);

            if (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted) {
                let $edit = $('<span class="ms edit-button" data-bind="visible: editing, click: edit" title="Edit Report">edit_square</span>');
                $div.append($edit);
            }
    
            let allowEditDrilldown = itemData.widget()?.itemConfig?.allowEditDrilldown ?? false;
            
            ko.applyBindings({
                itemData, 
                tabName: ko.computed(() => {
                    return replaceBasicHtmlContent(itemData.tabName());
                }),
                icon: ko.computed(function() {
                    return itemData.drilldownIndex === itemData.widget().tabOrWidget.drilldownManager.activeDrilldownIndex() && allowEditDrilldown ? "arrow_drop_down" : "arrow_right";
                }),
                editing: ko.computed(function() {
                    return workbook.workbookConfig.generalSettings.editing() && itemData.drilldownIndex === itemData.widget().tabOrWidget.drilldownManager.activeDrilldownIndex()
                        && (itemData.widget()?.itemConfig?.isReportConfig ?? false);
                }),
                edit: function() {
                    Ir.Components.ReportDesigner.ReportDesigner.showEditor(itemData.widget().tabOrWidget);
                },
                showTemplates: function (data, e) {
                    let drilldownManager = itemData.widget().tabOrWidget.drilldownManager;
                    if (itemData.drilldownIndex === drilldownManager.activeDrilldownIndex() && allowEditDrilldown) {
                        let drilldownList: Array<Drilldown> = [];
                        for(let drilldown of drilldownManager.drilldownList()) {
                            drilldownList.push(drilldown);
                            if (drilldown.id === drilldownManager.getActiveDrilldown().id) {
                                break;
                            }
                        }
                        reportTemplateListPopoverControl.show(e.target, drilldownList);
                    }
                },
            }, $div[0]);
           
            itemElement.append($div);
        };

        this.tabsConfig = {
            items: tabOrWidget.drilldownManager.drilldownViewList as any,
            selectedIndex: tabOrWidget.drilldownManager.activeDrilldownIndex as any,
            width: '100%',
            height: "100%",
            animationEnabled: false,
            //swipeEnabled: true,
            tabsPosition: "top", 
            stylingMode: "secondary",
            iconPosition: "left" as any,
            showNavButtons: true,
            repaintChangesOnly: true,
            itemTitleTemplate: titleTemplate,
            noDataText: "",
            onSelectionChanged: async function (e) {
                if (e.addedItems && e.addedItems.length) {
                    let drilldownIndex = e.addedItems[0].drilldownIndex;
                    tabOrWidget.drilldownManager.drilldownViewList.splice(drilldownIndex + 1, 99);
                    tabOrWidget.drilldownManager.drilldownViewList()[drilldownIndex].drilldownFilters.removeAll();
                    tabOrWidget.drilldownManager.nextDrilldownId(tabOrWidget.drilldownManager.getNextDrilldown()?.id ?? -1);

                    //drillup or drill top
                    if (drilldownIndex < previousDrilldownIndex) {
                        let model = tabOrWidget.getBaseSubmitObject();
                        model.drilldownId = previousDrilldownId;
                        model.newDrilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
                        irGlobal.updateFromServer({},
                            urlConfigs.workBook + "NavigateToDrilldownLink",
                            model,
                            function (data) {
                            },
                            function (textStatus, errorThrown, errorItem: IError) {
                                errorItem.userMessage = "Failed to navigate to drilldown";
                                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                            },
                            true,
                            "POST",
                            false);
                    }
                    
                    //This will for the settings tabs to be updated when the drilldown is changed
                    config.isChangingTabOrWidget(true);
                    config.isChangingTabOrWidget(false);

                    previousDrilldownIndex = drilldownIndex;
                    previousDrilldownId = tabOrWidget.drilldownManager.activeDrilldownId;

                    setTimeout(function () {
                        self.tabsComponent.beginUpdate();
                        self.tabsComponent.option("showNavButtons", false);
                        self.tabsComponent.option("showNavButtons", true);
                        self.tabsComponent.endUpdate();

                        Ir.Components.ReportDesigner.ReportDesigner.reload(tabOrWidget);
                    }, 100); 
                }
            },
            onInitialized(e) {
                self.tabsComponent = e.component;
            }
        };

        tabOrWidget.widget.setResultAndConfig(params.result);

        this.tabDetailToolbar = {
            height: 31,
            items: [
                {
                    widget: 'dxButton',
                    location: 'before',
                    options: {
                        icon: 'arrowleft',
                        text: ko.computed(function () { return self.tab().detailingWidget.tabName() }),
                        onClick() {
                            self.tab().forceRefresh(true);
                            let detailTabId = self.tab().detailingWidget.tabId();
                            self.tab().detailingWidget.reset();
                            workbook.workbookConfig.setActiveTab(detailTabId);
                        }
                    }
                },
                {
                    location: 'center',
                    template() {
                        return $(`<div><b>${self.tab().detailingWidget.widgetName()}</b></div>`);
                    },
                }
            ]
        };
    }

}